// There is a single buy-credit tab (/settings?tab=buycredit). The SettingsPage picks the
// gateway (BD users: Moneybag/SSLCommerz by the `activePaymentGateway` Setting; everyone
// else: FastSpring) and the package type by the buyer's region internally, so every
// "Buy credit" CTA across the app points at the same tab and a non-BD user can never reach
// the BDT gateway by hand-editing the URL.
//
// These helpers used to map (gateway, country) → a per-gateway tab slug. They now always
// resolve to the unified tab; the params are kept so existing call sites don't have to change.
export const buyCreditTabFor = () => 'buycredit';
export const buyCreditPathFor = () => `/settings?tab=buycredit`;

/**
 * Hook: returns the buy-credit tab path. Kept as a hook (rather than a bare constant) so the
 * many `const buyCreditPath = useBuyCreditPath()` call sites keep working unchanged.
 */
export const useBuyCreditPath = () => buyCreditPathFor();
